// extracted by mini-css-extract-plugin
module.exports = {"hidden":"ImageWithPlaceholder_hidden__5Gawc","visible":"ImageWithPlaceholder_visible__1FHd2"};